// Environment configuration for the Outlook add-in
// Uses runtime configuration loaded from environments.json
import runtimeConfig from './runtimeConfig';
// Helper function to get environment value with fallback to process.env only during initialization
const getEnvValue = (key, defaultValue = '') => {
    // Try runtime config first (preferred) - use it if initialized, even if value is empty
    if (runtimeConfig.isInitialized()) {
        // Check if key exists in config (even if value is empty string)
        const allConfig = runtimeConfig.getAll();
        if (key in allConfig) {
            return runtimeConfig.getString(key, defaultValue);
        }
        // Key doesn't exist in runtime config, use default
        return defaultValue;
    }
    // Fallback to process.env ONLY during initialization (before runtime config loads)
    // This should rarely be used since we initialize config before app renders
    return process.env[key] || defaultValue;
};
const getEnvBoolean = (key, defaultValue = false) => {
    if (runtimeConfig.isInitialized()) {
        // Check if key exists in config
        const allConfig = runtimeConfig.getAll();
        if (key in allConfig) {
            return runtimeConfig.getBoolean(key, defaultValue);
        }
        return defaultValue;
    }
    // Fallback to process.env ONLY during initialization
    return process.env[key] === 'true' || defaultValue;
};
export const environment = {
    // Azure AD Configuration
    get AZURE_CLIENT_ID() {
        return getEnvValue('REACT_APP_AZURE_CLIENT_ID', '');
    },
    get AZURE_AUTHORITY() {
        return getEnvValue('REACT_APP_AZURE_AUTHORITY', '');
    },
    get AZURE_REDIRECT_URI() {
        return getEnvValue('REACT_APP_AZURE_REDIRECT_URI', '');
    },
    // API Scopes
    get AZURE_API_SCOPES() {
        return getEnvValue('REACT_APP_AZURE_API_SCOPES', 'api://d3398715-8435-43df-ac85-d28afd62f0e3/access_as_user');
    },
    get AZURE_GRAPH_SCOPES() {
        return getEnvValue('REACT_APP_AZURE_GRAPH_SCOPES', 'https://graph.microsoft.com/Mail.Send');
    },
    get AZURE_GLOBAL_SCOPES() {
        return getEnvValue('REACT_APP_AZURE_GLOBAL_SCOPES', 'openid,profile,offline_access');
    },
    // API Keys
    get PLACEMENT_API_KEY() {
        return getEnvValue('REACT_APP_PLACEMENT_API_KEY', '');
    },
    get LOGGING_API_KEY() {
        return getEnvValue('REACT_APP_LOGGING_API_KEY', '');
    },
    // Debug Configuration
    get DEBUG_ENABLED() {
        return getEnvBoolean('REACT_APP_DEBUG_ENABLED', false);
    },
    get DEBUG_LEVEL() {
        return getEnvValue('REACT_APP_DEBUG_LEVEL', 'info');
    },
    // API Endpoints
    get PLACEMENT_API_URL() {
        return getEnvValue('REACT_APP_PLACEMENT_API_URL', '');
    },
    get LOGGING_API_URL() {
        return getEnvValue('REACT_APP_LOGGING_API_URL', '');
    },
    // Additional environment variables
    get CYBER_MRSNA_MAILBOX() {
        return getEnvValue('REACT_APP_CYBER_MRSNA_MAILBOX', '');
    },
    get DEFAULT_SHARED_MAILBOX() {
        return getEnvValue('REACT_APP_DEFAULT_SHARED_MAILBOX', '');
    },
    get DRAFT_EMAIL_SUBJECT() {
        return getEnvValue('REACT_APP_DRAFT_EMAIL_SUBJECT', '');
    },
};
// Helper function to get scopes as array
export const getScopesArray = (scopesString) => {
    return scopesString.split(',').map(scope => scope.trim());
};
